import classNames from 'classnames';
import * as React from 'react';
import { PageSection } from '~/Features/Layouts/Components/PageSection/PageSection';
import { PageSectionHeading } from '~/Features/Layouts/Components/PageSectionHeading/PageSectionHeading';
import type { HtmlString } from '~/Features/Types/HtmlString.csharp';
import { HtmlDiv } from '~/Partials/Controls/HtmlDiv';
import styles from './CardsSection.module.css';
import type { CardsSectionColorVariant } from './CardsSectionColorVariant';
import type { CardsSectionTabContent, CardsSectionTabsProps } from './CardsSectionTabs/CardsSectionTabs';
import { CardsSectionTabs } from './CardsSectionTabs/CardsSectionTabs';

export interface CardsSectionProps extends Pick<CardsSectionTabsProps, 'translations'> {
    heading: HtmlString;
    tabsLabel: string;
    tabs: CardsSectionTabContent[];
    id?: string;
    teaser?: HtmlString;
    colorVariant?: CardsSectionColorVariant;
    className?: string;
}

export const CardsSection: React.FC<CardsSectionProps> = props => {
    const { id, heading, teaser, tabsLabel, tabs, translations, colorVariant = 'light', className } = props;
    const richtextVariant = colorVariant === 'light' ? 'dark' : 'light';

    return (
        <PageSection id={id} className={classNames(styles.CardsSection, styles[`Variant--${colorVariant}`], className)}>
            {heading && <PageSectionHeading heading={heading} className={styles.Heading} />}
            {teaser && (
                <div className={styles.TeaserWrapper}>
                    <HtmlDiv
                        className={classNames(styles.Teaser, 'RichtextContent', `RichtextContent--${richtextVariant}`)}
                        html={teaser}
                    />
                </div>
            )}
            {tabs.length > 0 && (
                <CardsSectionTabs
                    label={tabsLabel}
                    tabContents={tabs}
                    translations={translations}
                    colorVariant={colorVariant}
                    listWrapperClassName={styles.ListWrapper}
                />
            )}
        </PageSection>
    );
};
